import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import close from "../../assets/icons/close.svg";
import "../../assets/css/addEuipment.css";
// import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import plus1 from "../../assets/icons/plus1.svg";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import edit from "../../assets/icons/edit.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import lucide_download from "../../assets/icons/lucide_download.svg";

import trash from "../../assets/icons/trash.svg";
const EditEquipment = () => {
    const [masterOptionsMap, setMasterOptionsMap] = useState({});
    const [errorrowMessages, setErrorrowMessages] = useState([]);
    const [editRowTemplateId, setEditRowTemplateId] = useState(null);
    const [assets, setAssets] = useState([]);
    const [assetId, setAssetId] = useState("");
    const [assetAttributes, setAssetAttributes] = useState([]);
    const [assetTemplates, setAssetTemplates] = useState([]);

    const [editRowIndex, setEditRowIndex] = useState(null);
    const [editRowValues, setEditRowValues] = useState({});

    const [templateMasters, setTemplateMasters] = useState({});
    const [assetMasters, setAssetMasters] = useState([]);

    const [formValues, setFormValues] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [rows, setRows] = useState({});

    const [errforsubmit, seterrforsubmit] = useState("");
    const [errors, setErrors] = useState({});


    const { equipment_id } = useParams();
    // const [equipment, setEquipment] = useState({});

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const [errorMessages, setErrorMessages] = useState([]);

    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [selectedTemplateName, setSelectedTemplateName] = useState(null);


    const customStyles = {
        control: (base, state) => ({
            ...base,
            height: "48px",
            width: "250px",
            minHeight: "48px",
            lineHeight: "30px",
            borderRadius: "12px",
            boxShadow: state.isFocused ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none",
            borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
            "&:hover": {
                borderColor: state.isFocused ? "#CED4DA" : base.borderColor,
            },
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menuList: (base) => ({
            ...base,
            padding: 0,
            maxHeight: "300px",
            overflowY: "auto",
        }),
        option: (base, state) => ({
            ...base,
            padding: "10px",
            color: "#171717",
            backgroundColor:
                state.isSelected || state.isFocused ? "#f4f4f4" : "white",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#f0f0f0",
            },
            lineHeight: "15px",
        }),
        placeholder: (base) => ({
            ...base,
            lineHeight: "15px",
        }),
        input: (base) => ({
            ...base,
            lineHeight: "15px",
            padding: "0",
        }),
    };

    useEffect(() => {
        const getAssetClass = async () => {
            try {
                const data = await fetchWrapper(
                    `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({}),
                    },
                    navigate
                );

                setAssets(data || []);
                getEquipment(); // Call getEquipment after fetching assets
            } catch (error) {
                console.error("Error fetching data:", error.message);
                if (error.message === "Unauthorized") {
                    navigate("/auth/login");
                }
            }
        };
        getAssetClass();
    }, [navigate]);

    const getEquipment = async () => {
        try {
            const data = await fetchWrapper(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/view/${equipment_id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}),
                },
                navigate
            );

            // setEquipment(data.data || {});
            setFormValues(data.data || {}); // Set form values with the fetched data
            setRows(data.data.templates || []); // Set rows with the fetched data
            setAssetId(data.data.asset_id); // Set the assetId state
            handleAssetClassChange(data.data.asset_id);
        } catch (error) {
            console.error("Error fetching data:", error.message);
            if (error.message === "Unauthorized") {
                navigate("/auth/login");
            }
        }
    };
    const handleEditInputChange1 = (id, selectedOption, isDropdown = false) => {
        setEditRowValues((prevValues) => {
            const updatedValue = {
                value: isDropdown
                    ? selectedOption?.label || "" // ✅ store label, not value/id
                    : selectedOption
            };

            return {
                ...prevValues,
                [id]: updatedValue,
            };
        });
    };
    const handleAssetClassChange = async (asset_id) => {
        setAssetId(asset_id);
        try {
            const data = await fetchWrapper(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-class-attribute/${asset_id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}),
                },
                navigate
            );

            setAssetAttributes(data.asset_attributes || []);

            try {
                await getAssetTemplates(asset_id);
            } catch (error) {
                console.error("Error fetching asset templates:", error.message);
                toast.error("Failed to fetch asset templates.");
            }

            try {
                await getAssetMasters(asset_id);
            } catch (error) {
                console.error("Error fetching asset masters:", error.message);
                toast.error("Failed to fetch asset masters.");
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
            toast.error("An error occurred while fetching data.");
            if (error.message === "Unauthorized") {
                navigate("/auth/login");
            }
        }
    };

    const getAssetTemplates = async (asset_id) => {
        try {
            const data = await fetchWrapper(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-templates/${asset_id}/attributes`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}),
                },
                navigate
            );
            setAssetTemplates(data || []);

            // Fetch template masters for each template
            const templateMastersPromises = data.map((template) =>
                getTemplateMasters(template, asset_id)
            );

            // Wait for all template masters promises to resolve
            const templateMastersData = await Promise.all(templateMastersPromises);

            // Create a map of template masters
            const templateMastersMap = data.reduce((acc, template, index) => {
                acc[template._id] = templateMastersData[index];
                return acc;
            }, {});

            // Set template masters state
            setTemplateMasters(templateMastersMap);
        } catch (error) {
            console.error("Error fetching data:", error.message);
            if (error.message === "Unauthorized") {
                navigate("/auth/login");
            }
        }
    };

    const getTemplateMasters = async (template, asset_id) => {
        try {
            const data = await fetchWrapper(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-masters/${template._id}/leaf-group`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        asset_id,
                    }),
                },
                navigate // Include navigate if needed for error handling
            );

            return data.data || []; // Ensure data is an array, handle null case
        } catch (error) {
            console.error("Error fetching data:", error.message);
            if (error.message === "Unauthorized") {
                navigate("/auth/login"); // Navigate to login if unauthorized
            }
            return []; // Handle error gracefully, return empty array or default value
        }
    };
    const getAssetMasters = async (asset_id) => {
        try {
            const data = await fetchWrapper(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-masters/${asset_id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}),
                },
                navigate
            );

            setAssetMasters(data.data || []);
        } catch (error) {
            console.error("Error fetching asset masters:", error.message);
            if (error.message === "Unauthorized") {
                navigate("/auth/login");
            }
        }
    };
    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: type === "file" ? files[0] : value,
        }));
    };

    const handleSelectChange = (templateId, masterId, value, text) => {
        setSelectedValues((prevValues) => ({
            ...prevValues,
            [templateId]: {
                ...prevValues[templateId],
                [masterId]: { value, text },
            },
        }));
    };

    const handleAttributeChange = (templateId, attributeId, value) => {
        setSelectedValues((prevValues) => ({
            ...prevValues,
            [templateId]: {
                ...prevValues[templateId],
                [attributeId]: { value },
            },
        }));
    };

    const validateRow = (templateId, assetTemplate) => {
        const selected = selectedValues[templateId] || {};
        let isValid = true;
        const newErrors = {};

        // Check all templateMasters fields
        if (templateMasters[templateId]) {
            templateMasters[templateId].forEach((templateMaster) => {
                if (
                    !selected[templateMaster.master_id] ||
                    !selected[templateMaster.master_id].value
                ) {
                    isValid = false;
                    newErrors[
                        templateMaster.master_id
                    ] = `${templateMaster.master_name} is required`;
                }
            });
        }

        // Check all attribute fields
        assetTemplate.attributes.forEach((attribute) => {
            if (!selected[attribute._id] || !selected[attribute._id].value) {
                isValid = false;
                newErrors[attribute._id] = `${attribute.display_name} is required`;
            }
        });

        if (!isValid) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [templateId]: {
                    ...prevErrors[templateId],
                    ...newErrors,
                    general: "",
                },
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [templateId]: {},
            }));
        }

        return isValid;
    };

    const handleAddClick = (templateId, assetTemplate) => {
        const currentRows = rows[templateId] || [];

        const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
        const selectedFirstDropdownValue = selectedValues[templateId]?.[firstTemplateMasterId]?.value;

        const duplicateFound = currentRows.some(
            (row) => row?.[firstTemplateMasterId]?.value === selectedFirstDropdownValue
        );

        if (duplicateFound) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [templateId]: {
                    ...(prevErrors[templateId] || {}),
                    [firstTemplateMasterId]: "This value is already taken.",
                },
            }));
            return;
        }

        if (currentRows.length < parseInt(assetTemplate.rowlimit)) {
            if (validateRow(templateId, assetTemplate)) {
                setRows((prevRows) => ({
                    ...prevRows,
                    [templateId]: [...currentRows, selectedValues[templateId]],
                }));

                setSelectedValues((prevValues) => ({
                    ...prevValues,
                    [templateId]: {},
                }));

                resetFormFields(templateId);

                // clear error after successful add
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [templateId]: {
                        ...(prevErrors[templateId] || {}),
                        [firstTemplateMasterId]: undefined,
                    },
                }));
            }
        } else {
            toast.error(`Row limit of ${assetTemplate.rowlimit} reached`);
        }
    };

    const resetFormFields = (templateId) => {
        const inputs = document.querySelectorAll(`.row-${templateId} input`);
        const selects = document.querySelectorAll(`.row-${templateId} select`);
        inputs.forEach((input) => (input.value = ""));
        selects.forEach((select) => (select.value = ""));
    };

    const handleDeleteClick = (e, templateId, rowIndex) => {
        e.preventDefault();
        setRows((prevRows) => ({
            ...prevRows,
            [templateId]: prevRows[templateId].filter(
                (_, index) => index !== rowIndex
            ),
        }));
    };
    const handleEditInputChange = (id, selectedOption, isDropdown = false) => {
        setEditRowValues((prevValues) => {
            const updatedValues = {
                ...prevValues,
                [id]: {
                    value: isDropdown ? selectedOption?.value || "" : selectedOption,
                    // Only include the label if it's a dropdown; otherwise, omit it
                    ...(isDropdown && { label: selectedOption?.label || "" }),
                },
            };

            return updatedValues;
        });
    };

    const handleEditClick = (templateId, rowIndex, assetTemplate) => {
        console.log("ebntered")
        const row = rows[templateId][rowIndex];
        setEditRowTemplateId(templateId);
        setEditRowIndex(rowIndex);
        setEditRowValues(() => {
            const initialValues = {};

            // Process templateMasters for dropdowns
            templateMasters[templateId].forEach((templateMaster) => {
                if (row[templateMaster.master_id]) {
                    initialValues[templateMaster.master_id] = {
                        value: row[templateMaster.master_id].value,
                        label: row[templateMaster.master_id].text || "", // Ensure text is used if available
                    };
                }
            });

            // Process attributes for text inputs
            assetTemplate.attributes.forEach((attribute) => {
                if (row[attribute._id]) {
                    initialValues[attribute._id] = {
                        value: row[attribute._id].value,
                        // label: row[attribute._id].text || row[attribute._id].label || "", // Use text or label if available
                    };
                }
            });

            return initialValues;
        });
    };
    const handleSaveClick = (templateId, e) => {
        e.preventDefault();

        const firstTemplateMasterId = templateMasters[templateId]?.[0]?.master_id;
        const editedFirstDropdownValue = editRowValues[firstTemplateMasterId]?.value;

        // check if that value exists in other rows
        const duplicateFound = rows[templateId].some((row, idx) => {
            return (
                idx !== editRowIndex &&
                row?.[firstTemplateMasterId]?.value === editedFirstDropdownValue
            );
        });

        if (duplicateFound) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [templateId]: {
                    ...(prevErrors[templateId] || {}),
                    [editRowIndex]: {
                        ...(prevErrors[templateId]?.[editRowIndex] || {}),
                        [firstTemplateMasterId]: "This value is already taken.",
                    },
                },
            }));
            return;
        }

        const updatedRows = rows[templateId].map((row, index) => {
            if (index === editRowIndex) {
                const updatedRow = { ...row };
                for (const key in editRowValues) {
                    updatedRow[key] = {
                        value: editRowValues[key].value,
                        text: editRowValues[key].label,
                    };
                }
                return updatedRow;
            }
            return row;
        });

        setRows((prevRows) => ({
            ...prevRows,
            [templateId]: updatedRows,
        }));

        // clear error after save
        setErrors((prevErrors) => ({
            ...prevErrors,
            [templateId]: {
                ...(prevErrors[templateId] || {}),
                [editRowIndex]: {},
            },
        }));

        // Reset after saving
        setEditRowTemplateId(null);
        setEditRowIndex(null);
        setEditRowValues({});
    };





    const renderFormField = (attribute) => {
        return (
            <div
                key={attribute._id}
                className="col d-flex flex-column addEuipment-form-col"
            >
                <label htmlFor={attribute.field_name} className="addEuipment-form-text">
                    {attribute.display_name}
                    <span style={{ color: "#dc3545" }}>{attribute.required && " *"}</span>
                </label>
                {errors[attribute.field_name] && (
                    <div
                        className="error mt-2"
                        style={{ color: "#dc3545", marginLeft: "8px" }}
                    >
                        {errors[attribute.field_name]}
                    </div>
                )}
            </div>
        );
    };



    const groupedItems = [];
    for (let i = 0; i < assetAttributes.length; i += 2) {
        groupedItems.push(assetAttributes.slice(i, i + 2));
    }
    const handleOpenuploadModal = (isOpen, templateId, templatename) => {
        setShowUploadModal(isOpen);
        setSelectedTemplateId(templateId);
        setSelectedTemplateName(templatename)// Store the template ID in state
    };
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const handleCloseUploadModal = () => {
        setErrorMessages("");
        setErrorrowMessages("");
        setShowUploadModal(false);
        setSelectedFile(null); // Clear the selected file
    };


  




    const fetchMasterValues = async (masterId) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API_URL1}/api/v1/get-masters`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ masterId }),
                }
            );
            console.log("response", response);
            if (!response.ok) throw new Error("Failed to fetch master values");
            const data = await response.json();
            return data || []; // return the array directly, no data.data
        } catch (error) {
            console.error("Error fetching master values:", error);
            return [];
        }
    };

    useEffect(() => {
        const loadAllMasterOptions = async () => {
            const newMap = {};

            for (const template of assetTemplates) {
                for (const attr of template.attributes) {
                    if (attr.master_id && !newMap[attr.master_id]) {
                        const options = await fetchMasterValues(attr.master_id);
                        newMap[attr.master_id] = options;
                    }
                }
            }

            setMasterOptionsMap(newMap);
        };

        loadAllMasterOptions();
    }, [assetTemplates]);



    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="container">
                    {assetTemplates &&
                        assetTemplates.map((assetTemplate, i) => (
                            <div className="row mb-4" key={i}>
                                <div
                                    className="d-flex justify-content-between align-items-center col-sm-12 mb-n2 mb-2"
                                >
                                </div>
                                <div className="table-responsive">
                                    <table className="table align-middle table-text">
                                        <thead className="table-head align-middle">
                                            <tr>
                                                <th className="text-center">#</th>
                                                {templateMasters[assetTemplate._id] &&
                                                    templateMasters[assetTemplate._id].map(
                                                        (templateMaster, j) => (
                                                            <th className="text-uppercase" key={j}>

                                                                {templateMaster.heading_name ? templateMaster.heading_name : templateMaster.master_name}
                                                            </th>
                                                        )
                                                    )}
                                                {assetTemplate.attributes &&
                                                    assetTemplate.attributes.map(
                                                        (attribute, k) => (
                                                            <th className="text-uppercase" key={k}>
                                                                {attribute.display_name}
                                                            </th>
                                                        )
                                                    )}

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {errors[assetTemplate._id] &&
                                                errors[assetTemplate._id].general && (
                                                    <tr>
                                                        <td colSpan="100%" className="text-center">
                                                            <div
                                                                className="error"
                                                                style={{ color: "#dc3545" }}
                                                            >
                                                                {errors[assetTemplate._id].general}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}


                                            {rows[assetTemplate._id] &&
                                                rows[assetTemplate._id].map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        <td>{rowIndex + 1}</td>
                                                        {templateMasters[assetTemplate._id] &&
                                                            templateMasters[assetTemplate._id].map(
                                                                (templateMaster, colIndex) => (
                                                                    <td key={colIndex}>
                                                                        {editRowTemplateId ===
                                                                            assetTemplate._id &&
                                                                            editRowIndex === rowIndex ? (
                                                                            <Select
                                                                                id={`edit_asset_class_${rowIndex}`}
                                                                                value={
                                                                                    editRowValues[
                                                                                        templateMaster.master_id
                                                                                    ]
                                                                                        ? {
                                                                                            value:
                                                                                                editRowValues[
                                                                                                    templateMaster
                                                                                                        .master_id
                                                                                                ].value,
                                                                                            label:
                                                                                                editRowValues[
                                                                                                    templateMaster
                                                                                                        .master_id
                                                                                                ].label,
                                                                                        }
                                                                                        : null
                                                                                }
                                                                                onChange={(selectedOption) =>
                                                                                    handleEditInputChange(
                                                                                        templateMaster.master_id,
                                                                                        selectedOption,
                                                                                        true
                                                                                    )
                                                                                }
                                                                                styles={customStyles}
                                                                                options={assetMasters
                                                                                    .filter(
                                                                                        (asset_master) =>
                                                                                            asset_master
                                                                                                .template_master_id
                                                                                                ?.master_id ===
                                                                                            templateMaster?.master_id
                                                                                    )
                                                                                    .map((asset_master) => ({
                                                                                        value: asset_master._id,
                                                                                        label:
                                                                                            asset_master.document_code,
                                                                                    }))}
                                                                                placeholder="Select One"
                                                                                isClearable={true}
                                                                                isSearchable={true}
                                                                                menuPortalTarget={document.body}
                                                                                menuPosition="fixed"
                                                                            />
                                                                        ) : (
                                                                            row[templateMaster.master_id]
                                                                                ?.text ||
                                                                            row[templateMaster.master_id]
                                                                                ?.value
                                                                        )}
                                                                        {errors[assetTemplate._id] &&
                                                                            errors[assetTemplate._id][rowIndex] &&
                                                                            errors[assetTemplate._id][rowIndex][templateMaster.master_id] && (
                                                                                <div
                                                                                    className="error"
                                                                                    style={{ color: "#dc3545" }}
                                                                                >
                                                                                    {errors[assetTemplate._id][rowIndex][templateMaster.master_id]}
                                                                                </div>
                                                                            )}
                                                                    </td>
                                                                )
                                                            )}

                                                        {assetTemplate.attributes.map((attribute, colIndex) => {
                                                            const {
                                                                master_id,
                                                                field_value,
                                                                field_type,
                                                                display_name,
                                                                _id: attributeId
                                                            } = attribute;

                                                            const hasFieldValues = Array.isArray(field_value) && field_value.length > 0;
                                                            const hasMaster = master_id && masterOptionsMap[master_id];

                                                            const options = hasMaster
                                                                ? masterOptionsMap[master_id]
                                                                : hasFieldValues
                                                                    ? field_value
                                                                    : [];

                                                            const isDropdown =
                                                                field_type === "list" ||
                                                                field_type === "select" ||
                                                                hasMaster ||
                                                                hasFieldValues;

                                                            const treatAsTextInput =
                                                                field_type === "string" ||
                                                                field_type === "date" ||
                                                                field_type === "textarea" || field_type === "number";

                                                            const storedValue = editRowValues[attributeId]?.value || "";

                                                            const selectedOption = options.find((opt) =>
                                                                typeof opt === "object"
                                                                    ? (opt.master_column_name || opt.document_code || "Unknown") === storedValue
                                                                    : opt === storedValue
                                                            );

                                                            const dropdownValue = selectedOption
                                                                ? {
                                                                    value: typeof selectedOption === "object"
                                                                        ? selectedOption._id
                                                                        : selectedOption,
                                                                    label: typeof selectedOption === "object"
                                                                        ? selectedOption.master_column_name || selectedOption.document_code || "Unknown"
                                                                        : selectedOption
                                                                }
                                                                : null;

                                                            return (
                                                                <td key={colIndex}>
                                                                    {editRowTemplateId === assetTemplate._id &&
                                                                        editRowIndex === rowIndex ? (
                                                                        isDropdown && !treatAsTextInput ? (
                                                                            <Select
                                                                                value={dropdownValue}
                                                                                onChange={(selectedOption) =>
                                                                                    handleEditInputChange1(attributeId, selectedOption, true)
                                                                                }
                                                                                options={options.map((opt) =>
                                                                                    typeof opt === "object"
                                                                                        ? {
                                                                                            value: opt._id,
                                                                                            label: opt.master_column_name || opt.document_code || "Unknown"
                                                                                        }
                                                                                        : { value: opt, label: opt }
                                                                                )}
                                                                                styles={customStyles}
                                                                                placeholder={`Select ${display_name}`}
                                                                                isClearable={true}
                                                                                isSearchable={true}
                                                                                menuPortalTarget={document.body}
                                                                                menuPosition="fixed"
                                                                            />
                                                                        ) : (
                                                                            <input
                                                                                type="text"
                                                                                value={editRowValues[attributeId]?.value || ""}
                                                                                onChange={(e) =>
                                                                                    handleEditInputChange1(attributeId, e.target.value, false)
                                                                                }
                                                                                placeholder={`Enter ${display_name}`}
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        row[attributeId]?.value || ""
                                                                    )}

                                                                    {/* Error display */}
                                                                    {errors[assetTemplate._id] &&
                                                                        errors[assetTemplate._id][attributeId] && (
                                                                            <div className="error" style={{ color: "#dc3545" }}>
                                                                                {errors[assetTemplate._id][attributeId]}
                                                                            </div>
                                                                        )}
                                                                </td>
                                                            );
                                                        })}


                                                        <td className="text-center">
                                                            {editRowTemplateId ===
                                                                assetTemplate._id &&
                                                                editRowIndex === rowIndex ? (
                                                                <button
                                                                    style={{ width: "150px" }}
                                                                    type="button"
                                                                    onClick={(e) =>
                                                                        handleSaveClick(
                                                                            assetTemplate._id,
                                                                            e
                                                                        )
                                                                    }
                                                                    className="addEuipment-update-btn"
                                                                >
                                                                    Save
                                                                </button>
                                                            ) : (
                                                                <>


                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}

                                            {(!rows[assetTemplate._id] ||
                                                rows[assetTemplate._id].length === 0) && (
                                                    <tr>
                                                        <td colSpan="100%" className="text-center">
                                                            <p style={{ color: "#dc3545" }}>
                                                                No data available.
                                                            </p>
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                </div>
            )}
        </>
    );
};

export default EditEquipment;
